import liff from "@line/liff";

export const LiffModule = {

  /** 送出 Flex Message
  *  @returns [true = 'success'] | [false = 'failed'] */
  async sendFlexMessages(message, closeLiffWindow = false) { 

    // 如果有開 Mock 就複製到剪貼簿，或者沒有登入也複製
    if (!liff.isLoggedIn()) {
      alert('Liff Not Loggined!');
      return true;
    }

    // 判斷 Liff 有沒有開啟這個功能 (如果沒有要自己去 Line Develop console 裡打開)
    if (liff.isApiAvailable('shareTargetPicker') === false) {
      console.error('Not support share picker');
      return false;
    }


    // 送出 Flex Message
    try {
      const liffResponse = await liff.shareTargetPicker(message);
      if (liffResponse) {
        // succeeded in sending a message through TargetPicker
        console.log(`[${liffResponse.status}] Message sent!`);
        return true;
      }
      else {
        const [majorVer, minorVer] = (liff.getLineVersion() || "").split('.');
        if (parseInt(majorVer) == 10 && parseInt(minorVer) < 11) {
          alert('TargetPicker was opened at least. Whether succeeded to send message is unclear')
        } else {
          console.log('TargetPicker was closed!')
        }
        return false;
      }
    }
    catch (error) {
      // something went wrong before sending a message
      console.log('something wrong happen');
      console.error(error);
      return false;
    }
    finally {
      if (closeLiffWindow) {
        LiffModule.closeLiffWindow();
      }
    }
  },

  async closeLiffWindow() {
    if (liff.isInClient()) {
      liff.closeWindow();
    }
  },

  async openWindow(url, external = false) {
    if (liff.isInClient()) {
      liff.openWindow({ url, external });
    }
  }
}


  